import React, { Component } from 'react'
import "./Museum.css"
import DefaultLayout from "../layout/Default";

class Museum extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        return (
            <DefaultLayout >
            <div className="all">
                <div>
                    <h1 className="title is-2 big-titles">When and Where Were Tattoos First Performed?</h1>
                    <p>
                        <br />
                    Tattoos date back many thousands of years.
                 In fact, we have firm evidence that tattooing is an ancient art form, after discoveries of tattoos on mummified skin were found.
                 The oldest evidence of human tattoos is believed to be from between 3370 BC and 3100 BC.

                  Otzi the Iceman was discovered in September 1991.
                His nickname comes from the location he was found in the Otzal Alps.
                His body has naturally mummified and preserved, making him Europe’s oldest human mummy.</p>
                    <img src="https://d3eh3svpl1busq.cloudfront.net/hKwyKHaPYdQPertjJeptpCwDngTecnnQ/assets/static/optimized/rev-d9bde98/wp-content/uploads/2018/10/Otzi-Iceman-Mummy.jpg" alt="" />
                    <footer>
                        Otzi The Iceman
                    </footer>
                </div>

                <div>
                    Otzi’s body has a total of 61 tattoos in various different locations, with the majority of these ink inscriptions located on his legs. Close examination of the markings on the mummy indicate that soot or fireplace ash were used to create the tattoos.

                    While Otzi may be evidence of the first tattoos known to mankind, other eras and ages throughout history reveal a long and rich history of tattooing. There is evidence of this from over 49 different locations around the world, where tattooed mummies and remains have been discovered.

                    Locations where tattooing practices have been recorded on human remains, include: Alaska, Mongolia, Greenland, Egypt, China, Sudan, Russia, and the Philippines. All of these discoveries link to different periods of time throughout ancient history. Some of these date back to 2100 BC.
            </div>
                <div>
                    
                    <h1 className="title is-3x mt">Ancient and Traditional Practices</h1>
                    <p>As the first tattoos date back to ancient civilizations, the reasons behind the newly-seen skin tattoos are fuelled by different theories. These theories reflect the location and the cultures of the civilizations themselves. Let’s take a closer look at some of these civilizations and some theories about why they used to tattoo themselves.</p>
                    <img src="https://d3eh3svpl1busq.cloudfront.net/hKwyKHaPYdQPertjJeptpCwDngTecnnQ/assets/static/source/rev-d9bde98/wp-content/uploads/2018/10/History-Of-Tattoos.jpg" alt="" />
                    <footer>Tattoos in Iban culture</footer>
                    <br />
                </div>
                <div>

                    <h1 className="title is-3 small-titles"> China & Asia</h1>

                    Some cemeteries across western China in the province of Xinjiang have revealed a number of mummies with t

                    attooed skin. Some mummies date as far back as 2100 BC, while others are considerably younger, d
                    ating to around 550 BC. Within ancient Chinese practices, tattooing was considered to be barbaric
                    and was highly stigmatized.
                    <img src="https://d3eh3svpl1busq.cloudfront.net/hKwyKHaPYdQPertjJeptpCwDngTecnnQ/assets/static/optimized/rev-d9bde98/wp-content/uploads/2018/10/Tattooed-Mummy.jpg" alt="" />
                    <p>Ancient Chinese literature refers to folk heroes and bandits as having tattoos. It is also
                    thought to have been fairly common for convicted criminals to be branded with a tattoo on their face.
                          This tattoo was used to warn other members of society that this person could not be trusted.</p>
                </div>
                <div>
                    <p>
                      
                        <h3 className="title is-3 small-titles mt">Egypt</h3>
                There have been discoveries of tattooed mummies from ancient Egypt,
                which suggest that the practice here dates back to at least 2000 BC. Some theories indicate that the tattoos found on the mummies were for decorative purposes. Research by Daniel Fouquet suggests that, in ancient Egypt, tattoos may have even been performed as a medical treatment.

                    His examination of the different scars found on the mummified body o
                    f the priestess, Hathor, suggests that the markings could have been a treatment for pelvic peritonitis. Another interesting discovery about tattooing from ancient Egypt is that it appears this practice was only carried out on the skin of women.

                        This theory is supported by the fact that there is little to no ev
                        idence, either physical or artistic, that tattooing was commonly performed on men. This practice changed, however, during the Meroitic period, between 300 BC and 400 CE, when Nubian men received tattoos.</p>
                </div>
                <div>
                  
                    <p><h3 className="title is-3 small-titles mt">Samoa</h3>
                Tattooing has formed a part of Samoan cultural traditions for tho
                usands of years. The history of tattooing in Samoa is a great example of how
                 tattoos can form an integral part of social culture. It is even believed that
                 the modern-day English word ‘tattoo’ may have originated from the Samoan word for tattoo ‘tatau’.

                The tradition of giving and receiving tattoos by hand in Samoa has
                been practiced for more than two thousand years. The techniques and tools u
                sed for this traditional practice have hardly changed during this time either. The skill is taught and passed down from father to son.

                The tool used to give the tattoos is handmade, from turtle shel
                l and boar’s teeth. The process of receiving traditional tattoos takes many
                weeks to complete. Tattooing ceremonies are generally held to mark a younger chief’s ascension to a leadership role within society.

                Once complete, the tattoos represent and celebrate dedication to t
                he culture and great endurance. These tattoos are extremely painful to recei
                ve and the procedure comes with a great risk of infection. Unfortunately, those who
                are unable to endure the pain can be branded with the mark of shame on their skin forever.</p>
                    <img src="https://d3eh3svpl1busq.cloudfront.net/hKwyKHaPYdQPertjJeptpCwDngTecnnQ/assets/static/optimized/rev-d9bde98/wp-content/uploads/2018/10/Poke-and-Stick.jpg" alt="" />
                </div>
                <div>
                  
                    <p><h3 className="title is-3 small-titles mt">Ancient Greece & Ancient Rome</h3>
                    Written records provide evidence of tattooing from the 5th centu
                    ry BCE in Greece. Tattoos during this era in Greece and Rome were used
                     mainly on the outcasts of society. Criminals, prisoners of war, and slaves would be branded with their status.

                    A famous example of the use of tattoos by the Ancient Greeks was
                     the Athenians tattooing owls onto the Samians after defeating them. Eviden
                     ce shows the use of the verb ‘stizein’, which means to prick when referring to tattooing in their ancient literature.

                    Throughout Ancient Rome there is also evidence of soldiers as
                    well as arms manufacturers getting tattoos. It is believed that this practi
                    ce continued right through into the 9th century. Slaves were also marked with a tattoo in Ancien
                    t Roman times to show they had paid their taxes.</p>
                </div>
                <div>
                   
                    <p><h3 className="title is-3 small-titles mt">Popular Styles Throughout Time</h3>
                Tattoos were not very common or socially acceptable until the mid 20th century. Up until this time, they were reserved for a small population, mainly those in the entertainment industry. Fully tattooed people became a popular attraction in and of themselves.
<br />  <br/>
                        <h2 className="title is-2 big-titles">Ink for Entertainment</h2>
                   
                        <h3 className="title is-3 small-titles mt">John O’Reilly</h3>
                        <br/>
                One of the most famous tattooed people from the 1800s was John O’Reilly. His elaborate and complete body art made him a popular feature in dime museums and the circus, where his tattoos attracted and amazed the audience.

                John O’Reilly was known as the “Tattooed Irishman” and he had a variety of intricate tattoos covering his whole body. One of the earliest mentions of O’Reilly’s tattoos was in an article from the Brooklyn Daily Eagle.

                The issue, released on February 22, 1887, highlights his performance at a boxing match. They mention his tattoos are “hideous” and a reflection of his “barbarious practices.”</p>
                    <img src="https://d3eh3svpl1busq.cloudfront.net/hKwyKHaPYdQPertjJeptpCwDngTecnnQ/assets/static/optimized/rev-d9bde98/wp-content/uploads/2018/10/John-OReilly-768x1270.jpeg" alt="" />
                </div>
                <div>
                    <p><h3 className="title is-3 small-titles">Emma de Burgh</h3>
                    <br/>
                Emma de Burgh was a famous tattooed lady in the entertainment industry in the late 1880s. She worked alongside her husband, and both were inked by the same tattoo artist as John O’Reilly. De Burgh and her husband also became very popular performing in the sideshow world within Europe.

                They appeared in Berlin, Germany in 1891 and continued to amaze the European crowds for some years after. The design of their tattoos had many religious connotations, including links to the Last Supper and The Calvary.</p>
                    <img src="https://d3eh3svpl1busq.cloudfront.net/hKwyKHaPYdQPertjJeptpCwDngTecnnQ/assets/static/optimized/rev-d9bde98/wp-content/uploads/2018/10/Emma-de-Burgh.jpg" alt="" />
                </div>
                <div>
                    <p><h1 className="title is-2 big-titles">Tattoos Through the 20th Century</h1>
                    <br/>
Throughout the 20th century, popular styles of tattoo have evolved and changed. To examine the evolution of ink in more detail, we’ve broken it up into decades. Let’s take a closer look at the art form evolution of tattoos in western culture over the last hundred years.
<div>
<br/>
<h3 className="title is-4">1910s</h3>

At the beginning of the 20th century, the majority of tattoos were found on circus performers or sailors. Tattoos were used to tell someone’s personal story, as well as their professions. For example, it was common for a sailor to have an anchor tattoo.

Within the sailing community, tattoos also became a mark of belonging. Young sailors would be tattooed after joining, almost like an initiation ceremony, to welcome them on board.

From here, the traditional art form continued to grow and had somewhat more of a practical purpose. Many of the tattoos were used for identification purposes if sailors fell overboard or drowned.

Seamen would get tattoos from the different ports that they sailed to. The tattoos symbolized the different destinations as well as the length of their journey. A turtle tattoo would mean that a sailor had crossed the equator and a swallow tattoo symbolized a journey of 5,000 miles.

</div>
<div>
   

<h3 className="title is-4 mt">1920s</h3>

Throughout the 1920s, cosmetic tattoos became very popular among women. Many would get popular makeup trends tattooed on their faces, as makeup was too expensive to buy. Common makeup tattoos included eyebrows and lip liner.

Traditionally designed tattoos were still less common throughout society and were not very socially acceptable. It was still mainly the so-called outcasts, such as circus performers, sailors, and criminals, who sported tattoos. As tattoos were so socially unacceptable, most women would keep their cosmetic tattoos a secret.
</div>
<div>
    
<h3 className="title is-4 mt">1930s</h3>

Social security numbers appeared in the 1930s and everyone was told to memorize their personal number. Many resorted to tattooing their social security numbers onto their bodies so they would always have access to it.

However, tattoos were still not socially accepted. Those who got a social security number tattoo did so more out of necessity rather than desire. Those with a social security tattoo were not viewed in the same way as people with more decorative and personal tattoos. Tattoos were still only accepted on performers, sailors, and criminals. Not on upstanding members of society.

The 1930s saw new theories across society, that linked tattoos with repressed sexual desires. Albert Parry released a book, arguing that the whole process of getting a tattoo is essentially sexual. With literature like this circulating, it is no surprise that tattoos were taboo throughout this decade.
</div>
<div>
    
<h3 className="title is-4 mt">1940s</h3>

The 1940s saw the birth of the iconic ‘Sailor Jerry’ style of tattoo, created by Norman Keith Collins. He added color to tattoos by creating his own pigments and adding them to his tattoo designs. The classic designs of this decade feature bold motifs and plenty of colors.

Thematically, tattoos in the 40s were mostly centered around nautical or military motifs. There was also an increase in patriotic tattoos, due to WW2. The war saw an increase in women to the workplace as well as an increase in women getting tattoos.

This fundamental shift in tattoo design saw tattoo acceptance rise. Increased popularity meant that decorative ink came out of the shadows and was sported far more than in previous decades. Many of the Sailor Jerry style tattoos are classic and timeless, with people still choosing similar designs in the present day.
</div>
<div>
    
<h3 className="title is-4 mt">1950s</h3>

Throughout the 1950s, tattoos became a reflection of masculinity. While it became trendy, especially among ‘bad boys’ to have tattoos, there was still a negative social stigma around tattoos. Those with tattoos were more likely to be labeled as criminals or thugs.

Society had shifted backward slightly, and tattoos once again were seen as the mark of the outcast. For those who continued to get inked, the trend of nautical tattoos continued throughout the 50s. The decade also saw an increase in the popularity of chest tattoos.
</div>
<div>
    
<h3 className="title is-4 mt">1960s</h3>

Tattoo parlors in New York were blamed for an increase in hepatitis throughout the 1960s. While this may or may not have been true, it certainly created a negative stigma around the tattoo industry. This meant a lot of people steered clear of getting tattooed throughout this decade.

However, the 60s saw an increase of tattooed idols in the media, with famous musicians like Janis Joplin going under the needle. Celebrities flocked to Lyle Tuttle, who was one of the best and most reputable tattoo artists at the time.

Patriotic tattoos dropped in popularity, thanks to the Vietnam war. The classic skull and crossbones designs become particularly popular, especially among bikers.
</div>
<div>
    

 <h3 className="title is-4 mt">1970s</h3
                        >
The 1970s saw tattoos really becoming more mainstream and popular. No longer were they reserved for the outcasts of society, now regular people wanted to get them too. Peace symbols and messages of peace were particularly popular in this decade.

The 70s also saw a new style, with detailed and intricate designs, gaining popularity. Full sleeve tattoos and bodysuits began emerging on young people engaged in the counterculture.
</div>
<div>
<h3 className="title is-4 mt">1980s</h3>

The decade of rebellion that was the 1980s saw tattoos get bigger and brighter still. Bold black outlines, Celtic knots, and colorful motif designs rose in prominence. The music scene also impacted the flourishing tattoo industry, particularly rock and roll.

Many people would get inked after being inspired by their favorite rock star’s tattoos. By the 80s, society was finally on board and tattoos were, at last, socially acceptable—for most people anyway. Because stigmas dropped away, more and more ‘regular’ people got tattoos.
</div>
<div>
    
<h3 className="title is-4 mt">1990s</h3>

Just like in the 1980s, celebrities played a big part in the main tattoo trends of the 90s. One of the most iconic and popular tattoo designs of the 90s was Pamela Anderson’s barbed-wire armband. Other popular designs from this decade include tribal designs, Chinese letters, as well as tattoos of the sun.

Questions about the West’s use of tribal and traditional tattoo designs started being asked across the world. The rise of digital communications enabled global debates about ethics and appropriation.

    </div>
    <div>
    <br/>
<h3 className="title is-4 mt">2000s</h3>

The beginning of the 21st century saw lower back tattoos increase in popularity. The so-called “tramp stamp” became one of the most fashionable places for women to get tattoos. Butterfly and Yin-Yang symbols also gained traction.

Celebrities continued to steer tattoo trends of tattoos throughout the ‘noughties’. Star tattoos rose in popularity, largely thanks to the singer, Rihanna.
</div>
<h3 className="title is-4 mt">2010s</h3>

So far, the 2010s have seen trends related to both the design and the placement of tattoos. Small tattoos in unusual places, like the fingers or behind the ears are now very popular. Many people are opting for quirky and creative designs.</p>
                </div>
                <div>
                    <p>
                        Modern Day Tattoo Equipment
                        The tattoo guns that are used today came from more humble beginnings in 1891. The first electric tattoo machine was patented by Samuel O’Reilly. The design was based on a modified version of the electric pen, created by Thomas Edison. The arrival of the electric tattoo machine saw a steady increase in the popularity of tattoos.
                </p>
                    <img src="https://d3eh3svpl1busq.cloudfront.net/hKwyKHaPYdQPertjJeptpCwDngTecnnQ/assets/static/optimized/rev-d9bde98/wp-content/uploads/2018/10/Coil-Tattoo-Machines.jpg" alt="" />
                    <p>Inks used in the guns were created using geological or mineral sources. Black ink was made using iron oxide or carbon, and cinnabar was used to make red. Different shades of orange, red, and yellow were made using different cadmium compounds.

Recent, modern technology has seen a shift away from mineral-based pigments. Organic pigments are now more commonly used. Modern-day inks also contain a variety of fillers, binding agents and preservatives.</p>
                </div>
                <div>
                    <p>
                        Summary
                        Tattoos are an inherent part of some cultures. In the Western world, it has taken time for decorative ink to become socially acceptable. It’s really only in the last fifty years that tattoos have become popular and mainstream.

                        The evidence of tattooing in ancient civilizations is fascinating. Tattoos from these past civilizations tended to have links to medical healing, as opposed to the cosmetic value that they have today. There is still so much waiting to be discovered and found out about tattoos throughout histor
                </p>
                </div>
            </div>
            </DefaultLayout>
        )
    }
}

export default Museum
